import mockAxios, { AxiosResponse } from 'axios';

import { IEmployeeWorkgroupServiceMock } from './employee-workgroup.mock.types';

export const mockEmployeeWorkgroupService = (): IEmployeeWorkgroupServiceMock => ({
  fetchEmployeeWorkgroups: jest.fn(),
  fetchEmployeeWorkgroup: jest.fn(),
  createEmployeeWorkgroup: jest.fn(),
  updateEmployeeWorkgroup: jest.fn(),
  deleteEmployeeWorkgroup: jest.fn()
});

export const mockEmployeeWorkgroupAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
